<template>
  <router-link class="card" tag="article" :to="`/properties/${ property.MLS }`" :style="image">
    <div class="header">
      <div>
        <tag color="red">{{ property.ContractType }}</tag>
        <tag>{{ property.TransactionType }}</tag>
      </div>
      
      <img class="icon" src="@/assets/icons/heart.svg" alt="" @click.stop="removeLikedProperty(property.MLS)">
    </div>

    <div class="footer t-center">
      <h1 class="title h5 t-inverse">{{ property.TotalBedrooms }} Bedroom {{ property.PropertyType }}</h1>
      <h2 class="location-price h5 t-normal t-inverse">{{ property.Town }}, Malta | {{ property.Price | formatPrice }}</h2>
    </div>
  </router-link>
</template>

<style scoped lang="scss">
  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 130px;
    padding: 10px;
    margin-bottom: 20px;
    border-radius: 4px;
    background-size: cover;
    background-position: center;

    cursor: pointer;

    @include min-sm {
      width: 47%;
      height: 240px;
      margin: 15px 10px;
    }

    @include min-md {
      width: 31%;
    }

    .header {
      display: flex;
      justify-content: space-between;

      .icon {
        width: 2.2rem;
        height: 2.2rem;

        @include min-sm {
          width: 3rem;
          height: 3rem;
        }
      }
    }

    .footer {
      margin-top: auto;

      .h5 {
        margin-bottom: 0;

        @include min-sm {
          margin-bottom: 5px;
        }
      }
    }
  }
</style>

<script>
  import { mapActions } from 'vuex';

  import { formatPrice } from '@/filters'
  import Tag from '@/components/Tag';

  export default {
    name: 'CardFavourite',

    components: {
      Tag
    },

    filters: {
      formatPrice
    },

    props: {
      property: {
        type: Object,
        required: true
      }
    },

    computed: {
      image () {
        return `background-image: linear-gradient(to bottom, rgba(var(--black), 0), rgba(var(--black), 0.7)), url('${ this.property.Image }')`
      }
    },

    methods: {
      ...mapActions([
        'removeLikedProperty'
      ])
    }
  };
</script>